import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, CircularProgress, Typography } from '@mui/material';
import { useAuthStore } from '../stores/authStore';
import { GOOGLE_REDIRECT_URI } from '../config/api';

/**
 * Landing page for Google OAuth redirect.
 * URL: /auth/callback?code=...&state=...
 * Extracts the code and hands it to the auth store.
 */
const AuthCallbackPage = () => {
  const navigate = useNavigate();
  const { loginWithGoogle, error } = useAuthStore();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const params = new URLSearchParams(window.location.search);
    const code = params.get('code');
    const errorParam = params.get('error');

    if (errorParam) {
      navigate('/login?error=' + encodeURIComponent(errorParam));
      return;
    }

    if (!code) {
      navigate('/login?error=no_code');
      return;
    }

    loginWithGoogle(code, GOOGLE_REDIRECT_URI).then(() => {
      if (useAuthStore.getState().isAuthenticated) {
        navigate('/', { replace: true });
      } else if (useAuthStore.getState().requiresSiteSelection) {
        navigate('/login', { replace: true });
      } else {
        navigate('/login?error=auth_failed', { replace: true });
      }
    });
  }, []);   // eslint-disable-line react-hooks/exhaustive-deps

  if (error) {
    return (
      <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" minHeight="100vh">
        <Typography color="error">{error}</Typography>
      </Box>
    );
  }

  return (
    <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" minHeight="100vh" gap={2}>
      <CircularProgress />
      <Typography color="text.secondary">Signing you in…</Typography>
    </Box>
  );
};

export default AuthCallbackPage;
